const add_form = {
  namespaced: true,
  state: {
    add_form_show: false,
    form_type: 'add',
    default_form: {
      id: '',
      title: '',
      fields: `{"contentList":[{"title":"Company name","type":"input","moduleName":"company","name":"company","value":"","placeholder":"Please enter company name","show":true,"checkType":"","require":true,"disabled":false,"isSystem":true,"display":false,"width":"100%","id":1},{"title":"Contact","type":"input","moduleName":"username","name":"username","value":"","placeholder":"Please enter a contact","show":true,"checkType":"","require":true,"disabled":false,"isSystem":true,"display":false,"width":"100%","id":2},{"title":"Phone number","type":"input","moduleName":"phone","name":"phone","value":"","areaSelect":"false","enterDigitsSelect":"true","placeholder":"Please enter the phone number","show":true,"checkType":"phone","require":true,"disabled":false,"isSystem":true,"display":false,"width":"100%","id":3},{"title":"Mail","type":"input","moduleName":"email","name":"email","value":"","placeholder":"Please input your email","show":true,"checkType":"email","require":true,"disabled":false,"isSystem":true,"display":false,"width":"100%","id":4},{"title":"Content","type":"textarea","moduleName":"content","name":"content","value":"","placeholder":"Please enter Content","show":true,"checkType":"","require":true,"disabled":false,"isSystem":true,"display":false,"width":"100%","id":5}],"buttonName":"Submit","popupName":"Submit Form","textAlign":"left","buttonWidth":"100%","verifyWidth":"100%","verifyCodeShow":true}`,
    },
    form: [],
    form_list: [],
    edit_form: [],
    form_length: 0,
    form_title: ''
  },
  mutations: {
    set_add_form_show(state, val) {
      state.add_form_show = val
    },
    set_form_type(state, val) {
      state.form_type = val
    },
    set_form_list(state, val) {
      state.form_list = val
    },
    set_edit_form(state, val) {
      state.edit_form = val
    },
    set_form_length(state, val) {
      state.form_length = val
    },
    set_form_title(state, val) {
      state.form_title = val
    },
  },
  actions: {
  }
}

export default add_form



// WEBPACK FOOTER //
// ./src/vuex/modules/add_form.js